<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <v-form ref="create_data" @submit.prevent="create_data">
          <div class="grid_header">
            <div></div>
            <div class="text-center ma-4">
              <div class="text_font">ฟอร์มส่งคืน/เปลี่ยนสินค้า</div>
              <div>บริษัท ฟาร์มาแคร์ พลัส จำกัด</div>
            </div>
            <div class="ma-4">
              <div class="grid_flex justify-end">
                <div class="mr-2">เลขที่เอกสาร :</div>
                <div>{{ save_data.doc_no }}</div>
              </div>
              <!-- <div class="grid_flex justify-end">
                <div class="mr-2">TF :</div>
                <div>{{ save_data.tf_no }}</div>
              </div> -->
            </div>
          </div>
          <!--          <div class="grid_list_input">-->
          <!--            <div class="grid_input">-->
          <!--              <div class="ma-4">-->
          <!--                <v-autocomplete clearable color="#86bc3a" :items="supplier_list" item-text="name" item-value="id" @input="get_product_list(save_data.supplier_id)" v-model="save_data.supplier_id" prepend-inner-icon="mdi-domain" label="บริษัทซัพพลายเออร์" hide-details="auto" outlined></v-autocomplete>-->
          <!--              </div>-->
          <!--              <div class="ma-4">-->
          <!--                <v-text-field color="#86bc3a" label="ผู้แทน" prepend-inner-icon="mdi-account" :rules="[v => !!v || 'กรุณากรอกผู้แทน']" v-model="save_data.representative" hide-details="auto" outlined></v-text-field>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="grid_list_input">
            <div class="grid_input">
              <div class="ma-4">
                <v-autocomplete clearable color="#86bc3a" :items="supplier_list" item-text="name" item-value="id"
                  @input="get_product_list" v-model="save_data.supplier_id" prepend-inner-icon="mdi-domain"
                  label="บริษัทซัพพลายเออร์" hide-details="auto" outlined></v-autocomplete>
              </div>
              <div class="ma-4">
                <v-text-field color="#86bc3a" label="ผู้แทน" prepend-inner-icon="mdi-account"
                  :rules="[v => !!v || 'กรุณากรอกผู้แทน']" v-model="save_data.representative" hide-details="auto"
                  outlined></v-text-field>
              </div>
            </div>
            <div class="grid_input">
              <div class="ma-4">
                <v-menu ref="menu_return" v-model="menu_return" :close-on-content-click="false"
                  :return-value.sync="save_data.returndate" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="save_data.returndate"
                      label="วันที่แจ้งคืนสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่แจ้งคืนสินค้า']"
                      prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH_return(returnEN)" v-model="returnEN"
                    :max="startDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="returnDate(save_data.returndate)">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_return = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <!--              <div class="ma-4 mobile_input">-->
              <!--                <v-menu ref="menu_delivery" v-model="menu_delivery" :close-on-content-click="false" :return-value.sync="save_data.dateofdelivery" transition="scale-transition" offset-y min-width="auto">-->
              <!--                  <template v-slot:activator="{ on, attrs }">-->
              <!--                    <v-text-field color="#86bc3a" v-model="save_data.dateofdelivery" label="วันที่ส่งสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่ส่งสินค้า']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>-->
              <!--                  </template>-->
              <!--                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(deliveryEN)" v-model="deliveryEN" no-title scrollable>-->
              <!--                    <v-spacer></v-spacer>-->
              <!--                    <v-btn text color="primary" @click="deliveryDate(save_data.dateofdelivery)">-->
              <!--                      ตกลง-->
              <!--                    </v-btn>-->
              <!--                    <v-btn text color="primary" @click="menu_delivery = false">-->
              <!--                      ยกเลิก-->
              <!--                    </v-btn>-->
              <!--                  </v-date-picker>-->
              <!--                </v-menu>-->
              <!--              </div>-->
              <div class="ma-4 mobile_margin">
                <v-autocomplete clearable color="#86bc3a" :items="user_list" item-text="name" item-value="id"
                  v-model="save_data.alerter" prepend-inner-icon="mdi-account-alert" label="ผู้แจ้งเตือน"
                  :rules="[v => !!v || 'กรุณากรอกผู้แจ้งเตือน']" hide-details="auto" outlined></v-autocomplete>
              </div>
            </div>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4">แจ้งโดย</div>
            <v-radio-group v-model="save_data.notified_by" mandatory>
              <div class="grid_checkbox_list">
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>Line.</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>โทร</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>ต่อหน้า</div>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4">สาเหตุที่ส่งคืน</div>
            <v-radio-group v-model="save_data.cause_return" mandatory>
              <div class="grid_checkbox_list">
                <div class="d-flex align-center mb-3">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>ของมาผิด</div>
                </div>

                <div class="d-flex align-center mb-3">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>ของไม่ได้สั่ง</div>
                </div>

                <div class="d-flex align-center mb-3">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>ชำรุด</div>
                </div>

                <div class="d-flex align-center mb-3">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="4"></v-radio>
                  </div>
                  <div>สินค้าหมดอายุ</div>
                </div>

                <div class="d-flex align-center mt-4">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="3"></v-radio>
                  </div>
                  <div v-if="save_data.cause_return !== 3" class="flex-grow-1">อื่นๆ</div>
                  <div v-if="save_data.cause_return === 3" class="flex-grow-1">
                    <v-text-field color="#86bc3a" label="รายละเอียด" v-model="save_data.note_cause" hide-details="auto"
                      required outlined dense></v-text-field>
                  </div>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4 red--text">วิธิการแก้ไข</div>
            <v-radio-group v-model="save_data.issue_select" mandatory>
              <div class="grid_checkbox_issue">
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>ทำใบ C/N.</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>คืนเป็นสินค้าเดิม</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>
                    <div v-if="save_data.issue_select !== 2">คืนเป็นสินค้าใหม่</div>
                    <div class="mt-n3 mr-4" v-if="save_data.issue_select === 2">
                      <v-text-field color="#86bc3a" label="รายละเอียด" prepend-inner-icon=""
                        v-model="save_data.note_issue" hide-details="auto" required outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="3"></v-radio>
                  </div>
                  <div>คืนไปเลยเพราะส่งผิด</div>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="d-flex align-center ma-4">
            <v-col cols="2">หมายเหตุ</v-col>
            <v-col cols="4">
              <v-text-field style="width: 400px" color="#86bc3a" label="หมายเหตุ" v-model="save_data.general_note"
                hide-details="auto" outlined></v-text-field>
            </v-col>
          </div>
          <div class="pa-2">
            <v-card-title>
              รายการสินค้าส่งคืน
            </v-card-title>
            <div class="grid_full pa-4">
              <div style="display: flex !important;">
                <v-autocomplete clearable color="#86bc3a" :items="product_list" item-text="product_name" item-value="id"
                  @input="addProduct" v-model="save_data.id" prepend-inner-icon="mdi-flask-plus-outline" label="สินค้า"
                  hide-details="auto" outlined />
              </div>
            </div>
            <v-data-table :headers="headers" :items="datalist" key="index" :footer-props="footer_Props"
              :items-per-page="per_page" mobile-breakpoint="0">
              <template v-slot:item="dataDetails">
                <tr>
                  <td>{{ dataDetails.index + 1 }}</td>
                  <td>{{ dataDetails.item.product_name }}</td>
                  <td>{{ dataDetails.item.lot_no }}</td>
                  <td>
                    <v-text-field color="#86bc3a" type="number" @keypress="isOnlyNumber($event)" label="จำนวน"
                      :rules="[v => !!v || 'กรุณากรอกจำนวน']" hide-details="auto" min="0"
                      v-model="dataDetails.item.quantity" outlined></v-text-field>
                  </td>
                  <td>{{ dataDetails.item.unit_name }}</td>
                  <td>
                    <div class="ma-4">
                      <v-text-field color="#86bc3a" label="หมายเหตุ" v-model="dataDetails.item.note"
                        prepend-inner-icon="" hide-details="auto" required outlined></v-text-field>
                    </div>
                  </td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDelete(dataDetails.item.loop_id, dataDetails.item.id)"
                      class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="pt-3 pb-5 text-center grid_btn">
            <v-btn x-large class="grad-success-bg white--text mr-4 ml-4" type="submit" style="font-size: 18px"
              :disabled="disabled">บันทึกข้อมูล</v-btn>
          </div>
        </v-form>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { minDate, onlyForNumber } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Government_receipt",
  data() {
    return {
      overlay: false,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      menu_delivery: false,
      menu_return: false,
      disabled: false,
      deliveryEN: '',
      returnEN: '',
      startDate: this.min_date(),
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      per_page: -1,
      supplier_list: [],
      user_list: [],
      save_data: {
        doc_no: null,
        tf_no: null,
        supplier_id: null,
        id: null,
        representative: '',
        dateofdelivery: '',
        returndate: '',
        alerter: '',
        notified_by: '',
        cause_return: '',
        note_cause: '-',
        issue_select: '',
        note_issue: '-',
        general_note: '',
      },
      headers: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '160px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '125px',
        },
      ],
      datalist: [],
      product_list: [],
      selected_arr: [],
      loop_id: 0,
    }
  },
  methods: {
    cache_page() {
      window.addEventListener('beforeunload', function (event) {
        event.preventDefault();
        event.returnValue = '';
      })
    },
    async deliveryDate(value) {
      this.$refs.menu_delivery.save(value)
      this.menu_delivery = false
    },
    async returnDate(value) {
      this.$refs.menu_return.save(value)
      this.menu_return = false
    },
    min_date: function () {
      return minDate()
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const date_th = day + '-' + month + '-' + year
      return this.save_data.dateofdelivery = date_th
    },
    diffDateTH_return(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const date_th = day + '-' + month + '-' + year
      return this.save_data.returndate = date_th
    },
    diffDateEN(value) {
      const diff = value.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    genDocumentCode() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/gettfno')
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.save_data.doc_no = res.data.doc_no
            this.save_data.tf_no = res.data.tf_no
          }
        })
    },
    getSupplier() {
      HTTP.post('/suppliers/all')
        .then((res) => {
          if (res.data.success === true) {
            this.supplier_list = res.data.object.map((obj) => {
              return {
                id: obj.id,
                name: obj.department !== '-' && obj.department !== null ? obj.name + ' (' + obj.department + ')' : obj.name,
              }
            })
          }
        })
    },
    get_product_list() {
      this.datalist = []
      HTTP.post('/returnproductdocs/getproductbysupplier', {
        supplier_id: this.save_data.supplier_id
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 2000)
          res.data.object.forEach((data) => {
            const id = this.loop_id += 1;
            this.datalist.push({
              loop_id: id,
              id: data.id,
              import_product_id: data.import_product_id,
              product_id: data.product_id,
              product_name: data.product_name,
              lot_no: data.lot_no,
              quantity: data.quantity,
              unit_id: data.unit_id,
              unit_name: data.unit_name,
              note: '',
            })
          })
          const pro_id = this.datalist.map((detail) => {
            return detail.id
          })
          this.selected_arr = pro_id
          this.get_product()
        }
      })
    },
    get_product() {
      this.product_list = []
      HTTP.post('/returnproductdocs/getproductbysupplier', {
        supplier_id: this.save_data.supplier_id
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            let inc = this.selected_arr.includes(data.id)
            if (inc === false) {
              this.product_list.push({
                cost: data.cost,
                created_at: data.created_at,
                date_expired: data.date_expired,
                discount_percent: data.discount_percent,
                discount_price: data.discount_price,
                discount_unit: data.discount_unit,
                exchange_status: data.exchange_status,
                id: data.id,
                import_product_id: data.import_product_id,
                is_delete: data.is_delete,
                lot_no: data.lot_no,
                price: data.price,
                product_code: data.product_code,
                product_id: data.product_id,
                product_name: data.product_name,
                quantity: data.quantity,
                status: data.status,
                supplier_id: data.supplier_id,
                supplier_name: data.supplier_name,
                unit_id: data.unit_id,
                unit_name: data.unit_name,
              })
            }
          })
        }
      })
    },
    async addProduct() {
      let value = this.product_list.filter((result) => {
        return result.id === this.save_data.id
      })
      value.forEach((data) => {
        const loop_id = this.loop_id += 1;
        this.datalist.push({
          loop_id: loop_id,
          id: data.id,
          import_product_id: data.import_product_id,
          product_id: data.product_id,
          product_name: data.product_name,
          lot_no: data.lot_no,
          quantity: data.quantity,
          unit_id: data.unit_id,
          unit_name: data.unit_name,
          note: '',
        })
      })
      this.selected_arr.push(this.save_data.id)
      this.get_product()
      await this.$nextTick(() => {
        this.save_data.id = null;
        this.alert_success = true;
        setTimeout(() => this.alert_success = false, 2000);
      })
    },
    getUser() {
      HTTP.post('/users/lists', {
        user_type: 2
      }).then((res) => {
        if (res.data.success === true) {
          this.user_list = res.data.object
        }
      })
    },
    create_data() {
      if (this.$refs.create_data.validate()) {
        if (this.datalist.length > 0) {
          Swal.fire({
            title: 'คุณต้องการบันทึกข้อมูลหรือไม่ !',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              this.overlay = true
              this.disabled = true
              HTTP.post('/returnproductdocs/create', {
                user_id: this.$store.state.userDetail.id,
                user_name: this.$store.state.userDetail.name,
                doc_no: this.save_data.doc_no,
                tf_no: this.save_data.tf_no,
                supplier_id: this.save_data.supplier_id,
                representative: this.save_data.representative,
                // delivery_date: this.deliveryEN,
                return_date: this.returnEN,
                alerter: this.save_data.alerter,
                notified_by: this.save_data.notified_by,
                cause_return: this.save_data.cause_return,
                note_cause: this.save_data.note_cause,
                issue_select: this.save_data.issue_select,
                note_issue: this.save_data.note_issue,
                general_note: this.save_data.general_note,
                data_list: this.datalist,
              }).then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  Swal.fire({
                    title: 'บันทึกข้อมูลสำเร็จ !',
                    icon: 'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then(() => {
                    this.$router.push('/stock/document/returnproductreceipt')
                  })
                }
                else {
                  Swal.fire({
                    title: 'บันทึกข้อมูลไม่สำเร็จ !',
                    text: res.data.message,
                    icon: 'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then(() => {
                    this.overlay = false
                    this.disabled = false
                  })
                }
              })
            }
          })
        }
        else {
          Swal.fire({
            title: 'พบข้อผิดพลาด !',
            text: 'รายการสินค้าห้ามว่าง !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        Swal.fire({
          title: 'พบข้อผิดพลาด !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getDelete(loop_id, id) {
      // product_list
      const find_product = this.datalist.filter(data => data.id === id)
      const map_product = find_product.map(data => data.id)
      const pop_id = map_product.pop()
      const index = this.selected_arr.indexOf(pop_id);
      if (index > -1) {
        this.selected_arr.splice(index, 1);
      }
      this.datalist = this.datalist.filter(data => data.id !== id)
      this.get_product()
      this.save_data.id = null
      this.alert_danger = true
      setTimeout(() => this.alert_danger = false, 2000);
    }
  },
  mounted() {
    this.genDocumentCode()
    this.getSupplier()
    this.getUser()
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.text_font {
  font-size: 26px;
}

.grid_flex {
  display: flex;
}

.grid_header {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_list_input {
  display: grid;
  /*grid-template-columns: 70% 30%;*/
  grid-template-columns: 50% 50%;
}

.grid_input {
  display: grid;
  /*grid-template-columns: 33.33% 33.33% 33.33%;*/
  grid-template-columns: 50% 50%;
}

.grid_checkbox {
  display: grid;
  grid-template-columns: 15% 85%;
}

.grid_checkbox_issue {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.grid_checkbox_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.mobile_margin {
  margin: 0;
}

@media only screen and (max-width: 1180px) {
  .grid_list_input {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_input {
    display: grid;
    /*grid-template-columns: 33.33% 33.33% 33.33%;*/
    grid-template-columns: 50% 50%;
  }

  .grid_checkbox_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }

  .grid_checkbox_issue {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}

@media only screen and (max-width: 700px) {
  .grid_header {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .mobile_margin {
    margin-top: -17px !important;
  }

  .grid_list_input {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_input {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_checkbox {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_checkbox_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }

  .grid_checkbox_issue {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }

  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .mobile_input {
    margin-top: -15px !important;
    margin-bottom: -10px !important;
  }
}
</style>
